import type { GetLinkableRequestsResponse } from "@nlc/shared-types";

import { type DefaultError, useQuery } from "@tanstack/react-query";

// eslint-disable-next-line import/no-restricted-paths
import { MOCKED_LINKABLE_REQUESTS } from "@/features/templates/mocks/requestDetails.ts";
import { linkableRequestsKeys } from "@/hooks/queryKeys.ts";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import apiClient from "@/lib/api/client.ts";

export interface LinkableRequest {
  id: number;
  textValue: string;
  type: null | string;
}

export function useGetLinkableRequests() {
  const { data: request } = useGetRequest();
  const requestId = request?.id;
  const { isTemplate } = useIsTemplate();

  return useQuery<GetLinkableRequestsResponse, DefaultError, LinkableRequest[]>(
    {
      enabled: !!requestId,
      queryFn: async () => {
        if (isTemplate) return MOCKED_LINKABLE_REQUESTS;

        return await apiClient
          .url(`/requests/${requestId}/linkable-requests`)
          .get()
          .json();
      },
      queryKey: linkableRequestsKeys.linkableRequestsByRequestId(requestId),
      select: (data) =>
        data.requests.map(({ id, name, requestType }) => ({
          id,
          textValue: name,
          type: requestType,
        })),
    },
  );
}
